(function () {
  function initGallery(gallery) {
    if (!gallery || gallery.dataset.wcPdpGalleryReady === 'true') return;

    gallery.dataset.wcPdpGalleryReady = 'true';

    var thumbs = Array.prototype.slice.call(
      gallery.querySelectorAll('[data-wc-gallery-thumb]')
    );

    var items = Array.prototype.slice.call(
      gallery.querySelectorAll('[data-wc-gallery-item]')
    );

    var openButtons = Array.prototype.slice.call(
      gallery.querySelectorAll('[data-wc-open-gallery-media]')
    );

    var lightbox = gallery.querySelector('[data-wc-gallery-lightbox]');
    var viewport = gallery.querySelector('[data-wc-gallery-viewport]');
    var closeButton = gallery.querySelector('[data-wc-gallery-close]');
    var prevButton = gallery.querySelector('[data-wc-gallery-prev]');
    var nextButton = gallery.querySelector('[data-wc-gallery-next]');

    var templates = Array.prototype.slice.call(
      gallery.querySelectorAll('[data-wc-gallery-template]')
    );

    var currentIndex = 0;
    var lastFocusedElement = null;
    var mobileVideoObserver = null;

    function isMobile() {
      return window.matchMedia('(max-width: 989px)').matches;
    }

    function getCount() {
      return templates.length;
    }

    function normalizeIndex(index) {
      var count = getCount();
      var nextIndex = parseInt(index, 10);

      if (Number.isNaN(nextIndex)) {
        nextIndex = 0;
      }

      if (nextIndex < 0) {
        return count - 1;
      }

      if (nextIndex >= count) {
        return 0;
      }

      return nextIndex;
    }

    function pauseMainVideos() {
      var videos = Array.prototype.slice.call(
        gallery.querySelectorAll('.wc-pdp-gallery__main video')
      );

      videos.forEach(function (video) {
        if (!video || typeof video.pause !== 'function') return;

        video.pause();
      });
    }

    function prepareVideo(video) {
      if (!video) return;

      video.muted = true;
      video.loop = true;
      video.playsInline = true;

      video.setAttribute('muted', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
    }

    function playVideo(video) {
      if (!video || typeof video.play !== 'function') return;

      prepareVideo(video);

      if (video.readyState < 2 && typeof video.load === 'function') {
        video.load();
      }

      video.play().catch(function () {});
    }

    function autoplayActiveDesktopVideo() {
      if (isMobile()) return;

      pauseMainVideos();

      var activeItem = gallery.querySelector('.wc-pdp-gallery__item.is-active');

      if (!activeItem) return;

      var activeVideo = activeItem.querySelector('video');

      if (!activeVideo) return;

      window.requestAnimationFrame(function () {
        window.setTimeout(function () {
          playVideo(activeVideo);
        }, 120);
      });
    }

    function setActiveMedia(index, options) {
      var settings = options || {};
      var shouldAutoplay = settings.autoplay !== false;

      currentIndex = normalizeIndex(index);

      items.forEach(function (item) {
        var itemIndex = parseInt(item.dataset.wcGalleryIndex, 10);
        var isActive = itemIndex === currentIndex;

        item.classList.toggle('is-active', isActive);

        if (isActive && isMobile()) {
          item.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start'
          });
        }
      });

      thumbs.forEach(function (thumb) {
        var thumbIndex = parseInt(thumb.dataset.wcGalleryIndex, 10);
        var isActive = thumbIndex === currentIndex;

        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      if (shouldAutoplay) {
        autoplayActiveDesktopVideo();
      }
    }
function normalizeMediaValue(value) {
  return String(value || '').split('?')[0];
}

function setActiveMediaFromVariant(detail) {
  if (!detail) return;

  var mediaId = normalizeMediaValue(detail.mediaId);
  var imageId = normalizeMediaValue(detail.imageId);
  var imageSrc = normalizeMediaValue(detail.imageSrc);

  if (!mediaId && !imageId && !imageSrc) return;

  var targetItem = items.find(function (item) {
    var itemMediaId = normalizeMediaValue(item.dataset.wcMediaId);
    var itemImageId = normalizeMediaValue(item.dataset.wcImageId);
    var itemImageSrc = normalizeMediaValue(item.dataset.wcImageSrc);

    return (
      (mediaId && itemMediaId === mediaId) ||
      (imageId && itemImageId === imageId) ||
      (imageSrc && itemImageSrc === imageSrc)
    );
  });

  if (!targetItem) return;

  setActiveMedia(targetItem.dataset.wcGalleryIndex, {
    autoplay: false
  });
}

gallery.addEventListener('wc:variant-media-change', function (event) {
  setActiveMediaFromVariant(event.detail || {});
});

gallery.wcSetActiveMediaFromVariant = setActiveMediaFromVariant;
    function getTemplate(index) {
      return gallery.querySelector(
        '[data-wc-gallery-template="' + index + '"]'
      );
    }

    function cloneTemplateContent(template) {
      var fragment = document.createDocumentFragment();

      Array.prototype.slice.call(template.childNodes).forEach(function (node) {
        fragment.appendChild(node.cloneNode(true));
      });

      return fragment;
    }

    function centerZoomedImage(imageWrap) {
      window.requestAnimationFrame(function () {
        imageWrap.scrollLeft = Math.max(
          0,
          (imageWrap.scrollWidth - imageWrap.clientWidth) / 2
        );

        imageWrap.scrollTop = Math.max(
          0,
          (imageWrap.scrollHeight - imageWrap.clientHeight) / 2
        );
      });
    }

    function prepareZoomImage() {
      var imageWrap = viewport.querySelector('.wc-pdp-gallery-lightbox__image-wrap');
      var image = viewport.querySelector('.wc-pdp-gallery-lightbox__image');

      if (!imageWrap || !image) return;

      var isMouseDown = false;
      var isTouchDown = false;
      var hasMoved = false;

      var startX = 0;
      var startY = 0;
      var startScrollLeft = 0;
      var startScrollTop = 0;

      function zoomIn() {
        imageWrap.classList.add('is-zoomed');
        centerZoomedImage(imageWrap);
      }

      function zoomOut() {
        imageWrap.classList.remove('is-zoomed');
        imageWrap.classList.remove('is-dragging');
        imageWrap.scrollLeft = 0;
        imageWrap.scrollTop = 0;
      }

      imageWrap.addEventListener('click', function () {
        if (hasMoved) {
          hasMoved = false;
          return;
        }

        if (imageWrap.classList.contains('is-zoomed')) {
          zoomOut();
        } else {
          zoomIn();
        }
      });

      imageWrap.addEventListener('mousedown', function (event) {
        if (!imageWrap.classList.contains('is-zoomed')) return;

        isMouseDown = true;
        hasMoved = false;

        startX = event.clientX;
        startY = event.clientY;
        startScrollLeft = imageWrap.scrollLeft;
        startScrollTop = imageWrap.scrollTop;

        imageWrap.classList.add('is-dragging');

        event.preventDefault();
      });

      document.addEventListener('mousemove', function (event) {
        if (!isMouseDown) return;

        var deltaX = event.clientX - startX;
        var deltaY = event.clientY - startY;

        if (Math.abs(deltaX) > 3 || Math.abs(deltaY) > 3) {
          hasMoved = true;
        }

        imageWrap.scrollLeft = startScrollLeft - deltaX;
        imageWrap.scrollTop = startScrollTop - deltaY;
      });

      document.addEventListener('mouseup', function () {
        if (!isMouseDown) return;

        isMouseDown = false;
        imageWrap.classList.remove('is-dragging');
      });

      imageWrap.addEventListener('touchstart', function (event) {
        if (!imageWrap.classList.contains('is-zoomed')) return;
        if (!event.touches || !event.touches.length) return;

        isTouchDown = true;
        hasMoved = false;

        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        startScrollLeft = imageWrap.scrollLeft;
        startScrollTop = imageWrap.scrollTop;

        imageWrap.classList.add('is-dragging');
      }, { passive: true });

      imageWrap.addEventListener('touchmove', function (event) {
        if (!isTouchDown) return;
        if (!event.touches || !event.touches.length) return;

        var deltaX = event.touches[0].clientX - startX;
        var deltaY = event.touches[0].clientY - startY;

        if (Math.abs(deltaX) > 3 || Math.abs(deltaY) > 3) {
          hasMoved = true;
        }

        imageWrap.scrollLeft = startScrollLeft - deltaX;
        imageWrap.scrollTop = startScrollTop - deltaY;
      }, { passive: true });

      imageWrap.addEventListener('touchend', function () {
        if (!isTouchDown) return;

        isTouchDown = false;
        imageWrap.classList.remove('is-dragging');
      });

      imageWrap.addEventListener('wheel', function (event) {
        if (!imageWrap.classList.contains('is-zoomed')) return;

        imageWrap.scrollLeft += event.deltaX;
        imageWrap.scrollTop += event.deltaY;
      }, { passive: true });
    }

    function autoplayLightboxVideo() {
      if (!viewport) return;

      var lightboxVideo =
        viewport.querySelector('video.wc-pdp-gallery-lightbox__video') ||
        viewport.querySelector('.wc-pdp-gallery-lightbox__video video') ||
        viewport.querySelector('video');

      if (!lightboxVideo) return;

      window.requestAnimationFrame(function () {
        window.setTimeout(function () {
          playVideo(lightboxVideo);
        }, 120);
      });
    }

    function pauseLightboxVideos() {
      if (!viewport) return;

      var videos = Array.prototype.slice.call(
        viewport.querySelectorAll('video')
      );

      videos.forEach(function (video) {
        if (!video || typeof video.pause !== 'function') return;

        video.pause();
      });
    }

    function openLightbox(index) {
      if (!lightbox || !viewport) return;

      currentIndex = normalizeIndex(index);

      var template = getTemplate(currentIndex);

      if (!template) return;

      lastFocusedElement = document.activeElement;

      pauseLightboxVideos();

      viewport.innerHTML = '';
      viewport.appendChild(cloneTemplateContent(template));

      lightbox.hidden = false;
      document.documentElement.classList.add('wc-gallery-lock');

      prepareZoomImage();
      autoplayLightboxVideo();

      if (closeButton) {
        closeButton.focus();
      }
    }

    function closeLightbox() {
      if (!lightbox || !viewport) return;

      pauseLightboxVideos();

      lightbox.hidden = true;
      viewport.innerHTML = '';
      document.documentElement.classList.remove('wc-gallery-lock');

      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
    }

    function showPrev() {
      currentIndex = normalizeIndex(currentIndex - 1);
      setActiveMedia(currentIndex);
      openLightbox(currentIndex);
    }

    function showNext() {
      currentIndex = normalizeIndex(currentIndex + 1);
      setActiveMedia(currentIndex);
      openLightbox(currentIndex);
    }

    function initMobileVideoAutoplay() {
      var main = gallery.querySelector('.wc-pdp-gallery__main');

      if (!main) return;

      var videos = Array.prototype.slice.call(
        gallery.querySelectorAll('.wc-pdp-gallery__main video')
      );

      if (!videos.length) return;

      videos.forEach(function (video) {
        prepareVideo(video);
      });

      if (!('IntersectionObserver' in window)) return;

      if (mobileVideoObserver) {
        mobileVideoObserver.disconnect();
      }

      mobileVideoObserver = new IntersectionObserver(function (entries) {
        if (!isMobile()) return;

        entries.forEach(function (entry) {
          var video = entry.target;

          if (entry.isIntersecting && entry.intersectionRatio >= 0.65) {
            playVideo(video);
          } else if (video && typeof video.pause === 'function') {
            video.pause();
          }
        });
      }, {
        root: main,
        threshold: [0, 0.35, 0.65, 0.9]
      });

      videos.forEach(function (video) {
        mobileVideoObserver.observe(video);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setActiveMedia(thumb.dataset.wcGalleryIndex, {
          autoplay: true
        });
      });
    });

    openButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var index = button.dataset.wcGalleryIndex;

        setActiveMedia(index, {
          autoplay: true
        });

        openLightbox(index);
      });
    });

    if (closeButton) {
      closeButton.addEventListener('click', closeLightbox);
    }

    if (prevButton) {
      prevButton.addEventListener('click', showPrev);
    }

    if (nextButton) {
      nextButton.addEventListener('click', showNext);
    }

    if (lightbox) {
      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox) {
          closeLightbox();
        }
      });
    }

    document.addEventListener('keydown', function (event) {
      if (!lightbox || lightbox.hidden) return;

      if (event.key === 'Escape') {
        closeLightbox();
      }

      if (event.key === 'ArrowLeft') {
        showPrev();
      }

      if (event.key === 'ArrowRight') {
        showNext();
      }
    });

    window.addEventListener('resize', function () {
      if (!isMobile()) {
        pauseMainVideos();
        autoplayActiveDesktopVideo();
      }
    });

    initMobileVideoAutoplay();

    setActiveMedia(0, {
      autoplay: false
    });
    gallery.dispatchEvent(
  new CustomEvent('wc:gallery-ready', {
    bubbles: true
  })
);
  }

  function initAllGalleries() {
    var galleries = document.querySelectorAll('[data-wc-pdp-gallery]');

    galleries.forEach(function (gallery) {
      initGallery(gallery);
    });
  }

  document.addEventListener('DOMContentLoaded', initAllGalleries);
  document.addEventListener('shopify:section:load', initAllGalleries);
})();